module.exports = __webpack_public_path__ + "img/P4-1-3.4ac85a53.svg";